import { Instance, types } from 'mobx-state-tree';
import { withSetPropAction } from '@/models/helpers/withSetPropAction';
import type {
  AmountDetailVo,
  AmountSummaryVo,
  SummaryItemVo,
} from '@/apis/checkout/checkout.interface';
import { SUMMARY, SUMMARY_DRAWER } from '@/apis/checkout/constants/constants';

export interface PaymentDetailItem extends SummaryItemVo {
  key: string;
  amountDetail: AmountDetailType[];
  saved?: string | null;
}

interface AmountDetailType extends AmountDetailVo {
  parentKey: string;
}

/**
 *
 * 价格相关计算与展示
 *
 */
export const PriceStoreModel = types
  .model('PriceStore')
  .props({
    amountSummary: types.frozen<AmountSummaryVo | null>(null),
  })
  .views((self) => ({
    // 共减 save price
    get savedPrice() {
      return self?.amountSummary?.promotionsTotal?.amount || null;
    },
    // 账单列表, 排序
    get amountSummaryList(): PaymentDetailItem[] {
      if (!self?.amountSummary) return [];
      // 排序
      const sort = {
        // Subtotal
        [SUMMARY.SUBTOTAL]: [],
        // Discounts
        [SUMMARY.DISCOUNTS]: [
          SUMMARY_DRAWER[SUMMARY.DISCOUNTS].DISCOUNT,
          SUMMARY_DRAWER[SUMMARY.DISCOUNTS].DISCOUNT_PLUS,
          SUMMARY_DRAWER[SUMMARY.DISCOUNTS].PROMOTION,
          SUMMARY_DRAWER[SUMMARY.DISCOUNTS].COUPONS,
          SUMMARY_DRAWER[SUMMARY.DISCOUNTS].TOTAL_DISCOUNTS,
        ],
        // Delivery fee or Pickup fee
        [SUMMARY.DELIVERY_PICKUP_FEE]: [],
        // Packaging fee
        [SUMMARY.PACKAGING_FEE]: [],
        // Order total
        [SUMMARY.ORDER_TOTAL]: [],
      };

      const operatorKey = { [SUMMARY.DISCOUNTS]: '-' };

      return Object.keys(sort)
        .map((key) => {
          const item: PaymentDetailItem = self?.amountSummary?.[key];

          return {
            ...item,
            key,
            // 埋点补充, 如果数据没有下发,默认-100
            amount: item?.amount || '-100',
            // 共减
            saved: key === SUMMARY.ORDER_TOTAL && this.savedPrice,
            operator: operatorKey[key],
            amountDetail:
              item?.amountDetail &&
              sort[key]
                .map((k) => item?.amountDetail?.filter((i) => i?.key === k)?.[0])
                .filter((v) => v)
                .map((i) => {
                  return { ...i, parentKey: key };
                }),
          };
        })
        ?.filter((i) => i?.label);
    },
  }))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    setAmountSummary(data: AmountSummaryVo) {
      console.log('amountSummary init', data);
      self.amountSummary = data;
    },
  }));

export interface PriceStoreModel extends Instance<typeof PriceStoreModel> {}
